import React from 'react';
import classes from './BootstrapSkeleton.module.scss';

export const BootstrapSkeleton: React.FC = () => <div className={classes.container} />;
